import { createConnectQueryKey, useQuery } from '@connectrpc/connect-query'

import { listUsers } from '@/gen/customer/management/v1/service-CustomerManagementService_connectquery'
import { CustomerManagementService } from '@/gen/customer/management/v1/service_pb'

import { defaultTransport } from '@/lib/connect/connect-transport'

export const getListUsersQueryKey = () => {
  return createConnectQueryKey({
    schema: CustomerManagementService.method.listUsers,
    cardinality: 'finite',
    transport: defaultTransport,
  })
}

export const useListUsers = (enabled = true) => {
  const queryState = useQuery(listUsers, {}, { enabled })

  return {
    ...queryState,
    data: queryState.data?.users || [],
  }
}
